import { render } from "./addReturn.vue?vue&type=template&id=1ac624d8"
import script from "./addReturn.vue?vue&type=script&lang=js"
export * from "./addReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__